import React, { type JSX } from "react";
import { MedicalCodeChip } from '@codametrix/ui-components';
import './styles/index.scss';
export interface GenericBaseCodeChip {
  code: string | number;
}

export interface GenericProcedureCodeChip extends GenericBaseCodeChip {
  units: number;
}

export interface GenericTechnicalCodeChip extends GenericProcedureCodeChip {}

export interface ProcedureAndTechCode {
  procedure: GenericProcedureCodeChip | null;
  technicalCode: GenericTechnicalCodeChip | null;
  displayTechnicalCodeUnits: boolean;
}

interface Props {
  diagnoses: GenericBaseCodeChip[] | null;
  modifiers: GenericBaseCodeChip[] | null;
  procedures: ProcedureAndTechCode[];
  title: string;
}

export function CodeSources({
  diagnoses,
  modifiers,
  procedures,
  title
}: Props): JSX.Element {
  return (
    <div className="code-source">
      <div className="code-source-heading">
        <span className="code-source-heading-text">{title}</span>
      </div>
      <div className="code-sections">
        <div className="procedures-and-modifiers-section">
          {procedures &&
            procedures.map((procedureRowEntry) => (
              <div
                className="procedure-and-technical-code"
                key={`${procedureRowEntry.procedure?.code}-${procedureRowEntry.technicalCode?.code}`}>
                {procedureRowEntry.procedure && (
                  <div className="code-source-units">
                    {procedureRowEntry.procedure.units}
                  </div>
                )}
                {procedureRowEntry.procedure && (
                  <MedicalCodeChip
                    key={procedureRowEntry.procedure.code}
                    code={procedureRowEntry.procedure.code}
                    codeType={'procedure'}
                    editable={false}
                    sequence={null}
                    handleCodeDelete={null}
                    isDraggable={false}
                    onDrop={null}
                  />
                )}
                {procedureRowEntry.technicalCode &&
                  procedureRowEntry.displayTechnicalCodeUnits && (
                    <div className="code-source-units">
                      {procedureRowEntry.technicalCode.units}
                    </div>
                  )}
                {procedureRowEntry.technicalCode && (
                  <MedicalCodeChip
                    key={procedureRowEntry.technicalCode.code}
                    code={procedureRowEntry.technicalCode.code}
                    codeType={'procedure'}
                    editable={false}
                    sequence={null}
                    handleCodeDelete={null}
                    isDraggable={false}
                    onDrop={null}
                  />
                )}
              </div>
            ))}
          {modifiers &&
            modifiers.map((modifier) => (
              <MedicalCodeChip
                key={modifier.code}
                code={modifier.code}
                codeType={'modifier'}
                editable={false}
                sequence={null}
                handleCodeDelete={null}
                isDraggable={false}
                onDrop={null}
              />
            ))}
        </div>
        <div className="diagnoses-section">
          {diagnoses &&
            diagnoses.map((diagnosis) => (
              <MedicalCodeChip
                key={diagnosis.code}
                code={diagnosis.code}
                codeType={'diagnosis'}
                editable={false}
                sequence={null}
                handleCodeDelete={null}
                isDraggable={false}
                onDrop={null}
              />
            ))}
        </div>
      </div>
    </div>
  );
}
